/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
	type CommonState,
	commonReducers,
	initialCommonState,
} from '../_common/commonReducers';

interface ContractsDetailsState extends CommonState {}

const initialState: ContractsDetailsState = {
	...initialCommonState,
};

// Contract details has a different DTO than contracts, so it gets its own
// isolated slice to avoid cross-contaminating structure/preset state when
// switching between the two grids.
const contractsDetailsSlice = createSlice({
	name: 'contractsDetails',
	initialState,
	reducers: {
		...commonReducers,
	},
});

export const {
	getTableStart,
	getTableSuccess,
	getTableFailure,
	getTableFinish,

	getItemStart,
	getItemSuccess,
	getItemFailure,

	createItemStart,
	createItemSuccess,
	createItemFailure,
	createItemFinish,

	updateItemStart,
	updateItemSuccess,
	updateItemFailure,
	updateItemFinish,

	deleteItemsStart,
	deleteItemsSuccess,
	deleteItemsFailure,
	deleteItemsFinish,

	deleteItemStart,
	deleteItemSuccess,
	deleteItemFailure,
	deleteItemFinish,

	getTableStructureStart,
	getTableStructureSuccess,
	getTableStructureFailure,

	getItemDocumentsStart,
	getItemDocumentsSuccess,
	getItemDocumentsFailure,
	getItemDocumentsFinish,

	uploadItemDocumentsStart,
	uploadItemDocumentsSuccess,
	uploadItemDocumentsFailure,
	uploadItemDocumentsFinish,

	deleteItemDocumentStart,
	deleteItemDocumentSuccess,
	deleteItemDocumentFailure,
	deleteItemDocumentFinish,

	getTableExcelStart,
	getTableExcelSuccess,
	getTableExcelFailure,
	getTableExcelFinish,
} = contractsDetailsSlice.actions;
export default contractsDetailsSlice;
